import { render, staticRenderFns } from "./ShipmentModal.vue?vue&type=template&id=8d25a95a&"
import script from "./ShipmentModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports